import { useEffect } from "react";

const SITE_URL = "https://osszhangegyesulet.hu";

const setMetaByName = (name, content) => {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setMetaByProperty = (property, content) => {
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const setCanonical = (href) => {
  let tag = document.querySelector('link[rel="canonical"]');
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", "canonical");
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
};

// Updates document title, meta description and Open Graph/Twitter tags for the current route.
// No react-helmet dependency: CRA's single index.html already carries good defaults,
// this just overrides them per page after mount.
export default function Seo({ title, description, path = "/" }) {
  useEffect(() => {
    if (title) {
      document.title = title;
      setMetaByProperty("og:title", title);
      setMetaByName("twitter:title", title);
    }
    if (description) {
      setMetaByName("description", description);
      setMetaByProperty("og:description", description);
      setMetaByName("twitter:description", description);
    }
    const canonicalUrl = `${SITE_URL}${path}`;
    setCanonical(canonicalUrl);
    setMetaByProperty("og:url", canonicalUrl);
  }, [title, description, path]);

  return null;
}
